// extracted by mini-css-extract-plugin
module.exports = {"select":"SpSelect_select__2f2LN","placeholder":"SpSelect_placeholder__1CLSf"};